import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import Home2View from "../views/Home2View.vue";
import PlayView from "../views/PlayView.vue";
import WaitView from "../views/WaitView.vue";
import MentionsView from "../views/MentionsView.vue";

Vue.use(VueRouter);

// Composant dynamique qui gère le changement à minuit
const DynamicHomeComponent = {
  data() {
    return {
      isAfterMidnight: false,
    };
  },
  created() {
    this.checkMidnight();
    // Vérifier toutes les minutes
    this.interval = setInterval(this.checkMidnight, 60000);
  },
  beforeDestroy() {
    // Nettoyer l'intervalle quand le composant est détruit
    clearInterval(this.interval);
  },
  methods: {
    checkMidnight() {
      const now = new Date();
      const startDate = new Date("2025-06-12T00:00:01");
      this.isAfterMidnight = now >= startDate;
    },
  },
  render(h) {
    return h(this.isAfterMidnight ? HomeView : WaitView);
  },
};

const routes = [
  {
    path: "/",
    name: "home",
    component: DynamicHomeComponent,
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/home2",
    name: "home2",
    component: Home2View,
  },
  {
    path: "/mentions",
    name: "mentions",
    component: MentionsView,
  },
  {
    path: "/play",
    name: "play",
    component: PlayView,
  },
  {
    path: "/status/:_id/:_secu",
    name: "status",
    component: () => import("../views/StatusView.vue"),
  },
  {
    path: "/finish",
    name: "finish",
    component: () => import("../views/FinishView.vue"),
  },
  {
    path: "/close",
    name: "close",
    component: () => import("../views/CloseView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/form",
    name: "form",
    component: () => import("../views/FormView.vue"),
  },
  {
    path: "/wait",
    name: "wait",
    component: () => import("../views/WaitView.vue"),
  },
  {
    path: "/done",
    name: "done",
    component: () => import("../views/DoneView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
